import { useEffect, useState } from "preact/hooks";
import {CP_API_TESTNET, NETWORKS} from "../../const/general";
import cx from "classnames";
import css from "./style.scss";
import { svgIcons } from "../../helpers/svg-helpers";
import {formatAddress, formatNumber} from "../../helpers/formatters-helpers";
import {
  changeEthereumNetwork, connectEthereumWallet,
  ethereumCreateTransaction,
  getEthereumBalance, getEthereumWallet
} from "../../api/ethereum";
import Loader from "../loader";

const ConnectMetamask = (props) => {
  const { to, amount, currency } = props;
  const [userAddress, setUserAddress] = useState("");
  const [userBalance, setUserBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  const connect = () => {
    setLoading(true);
    connectEthereumWallet(currency)
      .then((walletData) => {
        if (walletData) {
          setUserAddress(walletData.address);
          setUserBalance(walletData.balance);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      })
  }

  const pay = () => {
    setLoading(true);
    ethereumCreateTransaction(userAddress, to, amount, currency)
      .catch(() => setLoading(false));
  }

  useEffect(() => {
    setLoading(true);
    getEthereumWallet(currency)
      .then((walletData) => {
        if (walletData) {
          setUserAddress(walletData.address);
          setUserBalance(walletData.balance);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      })
  }, [setUserAddress, setUserBalance, setLoading]);

  useEffect(() => {
    if (userAddress) {
      window.ethereum.on('accountsChanged', (accounts) => {
        setLoading(true);
        getEthereumBalance(accounts[0], currency)
          .then((walletData) => {
            if (walletData) {
              setUserAddress(walletData.address);
              setUserBalance(walletData.balance);
              setLoading(false);
            }
          })
      })
    }
  }, [userAddress, setUserAddress, setUserBalance, setLoading]);

  useEffect(() => {
    if (userAddress) {
      window.ethereum.on('chainChanged', (chainId) => {
        setLoading(true);
        const chainNumber = parseInt(Number(chainId));
        if (NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].CHAIN !== chainNumber) {
          changeEthereumNetwork(userAddress, currency)
            .then(() => {
              setLoading(false);
            })
        } else {
          getEthereumBalance(userAddress, currency)
            .then((walletData) => {
              if (walletData) {
                setUserBalance(walletData.balance);
                setLoading(false);
              }
            })
        }
      })
    }
  }, [userAddress, setUserAddress, setUserBalance, setLoading]);

  return (
    <>
      {
        userAddress ? (
          <>
            <button
              className={cx(css.item)}
              onClick={() => pay()}
              disabled={loading || Number(userBalance) < Number(amount)}
            >
              <div className={cx(css.icon)}>{svgIcons.metamask()}</div>
              { loading ? (
                <>
                  <div className={cx(css.loader)} />
                  <div className={cx(css.loader)}>
                    <Loader />
                  </div>
                </>
              ) : (
                <>
                  <div className={cx(css.name)}>{formatAddress(userAddress)}</div>
                  <div className={cx(css.balance)}>{formatNumber(userBalance)}</div>
                </>
              ) }
            </button>
            {
              Number(userBalance) < Number(amount) ? (
                <span className={cx(css.error)}>Insufficient balance</span>
              ) : null
            }
          </>
        ) : (
          <button
            className={cx(css.item)}
            onClick={() => connect()}
            disabled={loading}
          >
            <div className={cx(css.icon)}>{svgIcons.metamask()}</div>
            { loading ? (
              <>
                <div className={cx(css.loader)} />
                <div className={cx(css.loader)}>
                  <Loader />
                </div>
              </>
            ) : (
              <>
                <div className={cx(css.name)}>Connect to MetaMask</div>
              </>
            ) }
          </button>
        )
      }
    </>
  );
};
export default ConnectMetamask;
